module.exports = __webpack_public_path__ + "static/media/favicon-scmp711.4e76d680.ico";